import { useState, useEffect } from 'react';
import { useAuthStore } from '../store/authStore';
import { translationService } from '../utils/translationService';

export function useTranslation() {
  const { user } = useAuthStore();
  const [userLanguage, setUserLanguage] = useState(user?.preferredLanguage?.toLowerCase() || 'fr');

  useEffect(() => {
    if (user?.preferredLanguage) {
      setUserLanguage(user.preferredLanguage.toLowerCase());
    }
  }, [user?.preferredLanguage]);

  const translate = async (text: string) => {
    if (!text) return '';
    return await translationService.translateText(text, userLanguage);
  };

  const getTranslatedContent = (item: any) => {
    if (!item?.translations || !item.translations[userLanguage]) {
      return {
        title: item.title || '',
        content: item.content || '',
        description: item.description || '',
        message: item.message || '',
        name: item.name || ''
      };
    }

    return {
      ...item.translations[userLanguage],
      title: item.translations[userLanguage].title || item.title || '',
      content: item.translations[userLanguage].content || item.content || '',
      description: item.translations[userLanguage].description || item.description || '',
      message: item.translations[userLanguage].message || item.message || '',
      name: item.translations[userLanguage].name || item.name || ''
    };
  };

  return {
    translate,
    getTranslatedContent,
    userLanguage
  };
}